<template>
    <div class="assembleLeft_option">
        <div class="assembleLeft_title">
            <b>试卷结构调整</b>
            <span></span>
        </div>
        <div class="assembleLeft_option_up">
            <el-radio-group v-model="assemble_template">
                <el-radio :label="1">简易模板</el-radio>
                <el-radio :label="2">正式模板</el-radio>
            </el-radio-group>
        </div>
        <div class="assembleLeft_option_down">
            <div class="el-checkbox-group">
                <el-checkbox v-model="struct_title" :true-label="1" :false-label="0">主标题</el-checkbox>
                <el-checkbox v-model="struct_notice" :true-label="1" :false-label="0">注意事项</el-checkbox>
                <el-checkbox v-model="struct_subtitle" :true-label="1" :false-label="0">副标题</el-checkbox>
                <el-checkbox v-model="struct_student" :true-label="1" :false-label="0">考生填写</el-checkbox>
                <el-checkbox v-model="struct_segment" :true-label="1" :false-label="0">大题组</el-checkbox>
                <el-checkbox :disabled="!struct_segment" v-model="struct_segmentmemo" :true-label="1" :false-label="0">大题注释</el-checkbox>
            </div>
        </div>
    </div>
</template>
<script>
import $store from '../store'
export default {
    computed:{
        assemblyData(){
            return $store.state.assemblyData
        },
        struct_title:{//主标题
            get(){
                return this.assemblyData.options.struct_title
            },
            set(val){
                $store.commit('RENEWASSEMBLESTORE',{name:['options','struct_title'],value:val})
            }
        },
        struct_subtitle:{//副标题
            get(){
                return this.assemblyData.options.struct_subtitle
            },
            set(val){
                $store.commit('RENEWASSEMBLESTORE',{name:['options','struct_subtitle'],value:val})
            }
        },
        struct_student:{//考生填写
            get(){
                return this.assemblyData.options.struct_student
            },
            set(val){
                $store.commit('RENEWASSEMBLESTORE',{name:['options','struct_student'],value:val})
            }
        },
        struct_notice:{//注意事项
            get(){
                return this.assemblyData.options.struct_notice
            },
            set(val){
                $store.commit('RENEWASSEMBLESTORE',{name:['options','struct_notice'],value:val})
            }
        },
        struct_segment:{//分大题
            get(){
                return this.assemblyData.options.struct_segment
            },
            set(val){
                if(!val){
                    this.struct_segmentmemo = false
                }
                $store.commit('RENEWASSEMBLESTORE',{name:['options','struct_segment'],value:val})
            }
        },
        struct_segmentmemo:{//大题注释
            get(){
                return this.assemblyData.options.struct_segmentmemo
            },
            set(val){
                $store.commit('RENEWASSEMBLESTORE',{name:['options','struct_segmentmemo'],value:val})
            }
        },
        assemble_template:{//模板
            get(){
                if(this.struct_title&&this.struct_subtitle&&this.struct_student&&this.struct_notice&&this.struct_segment&&this.struct_segmentmemo){
                    return 2
                }
                if(this.struct_title&&!this.struct_subtitle&&!this.struct_student&&!this.struct_notice&&this.struct_segment&&this.struct_segmentmemo){
                    return 1
                }
                return ''
            },
            set(val){
                this.switchTemplate(val)
            }
        }
    },
    methods: {
        switchTemplate(val){//切换模板
            if(val == 1){
                this.struct_title = 1//主标题
                this.struct_subtitle = 0//副标题
                this.struct_student = 0//考生填写
                this.struct_notice = 0//注意事项
                this.struct_segment = 1//分大题
                this.struct_segmentmemo = 1//大题注释
            }else{
                this.struct_title = 1
                this.struct_subtitle = 1
                this.struct_student = 1
                this.struct_notice = 1
                this.struct_segment = 1
                this.struct_segmentmemo = 1
            }
        },
    }
}
</script>




// WEBPACK FOOTER //
// packages/question-assembly/src/leftOption.vue